import React from 'react';
import { Clock, FileText, AlertTriangle, TrendingUp } from 'lucide-react';
import { StatsCard } from '../../components/ui/StatsCard';
import { Card } from '../../components/ui/Card';
import { DataTable } from '../../components/ui/DataTable';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { useAuth } from '../../contexts/AuthContext';
import { mockBatches } from '../../data/mockData';
export function BranchDashboard() {
  const {
    currentUser
  } = useAuth();
  return <div className="space-y-6" data-id="element-253">
      {/* Welcome Section */}
      <div className="flex flex-col md:flex-row md:items-center justify-between" data-id="element-254">
        <div data-id="element-255">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-256">Branch Dashboard</h2>
          <p className="text-gray-500" data-id="element-257">
            Overview for {currentUser?.branchId.toUpperCase()} Branch
          </p>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-258">
        <StatsCard title="My Pending Approvals" value="3" icon={Clock} color="amber" data-id="element-259" />
        <StatsCard title="Today's Batch Value" value="PKR 1.2M" icon={FileText} trend="up" trendValue="+15%" color="green" data-id="element-260" />
        <StatsCard title="Failed Title Fetches" value="2" icon={AlertTriangle} color="red" data-id="element-261" />
        <StatsCard title="Monthly Volume" value="PKR 45M" icon={TrendingUp} trend="up" trendValue="+8%" color="blue" data-id="element-262" />
      </div>

      {/* Recent Batches */}
      <Card title="Recent Payment Batches" data-id="element-263">
        <DataTable columns={[{
        header: 'Batch ID',
        accessor: 'id'
      }, {
        header: 'File Name',
        accessor: 'fileName'
      }, {
        header: 'Upload Date',
        accessor: item => new Date(item.uploadDate).toLocaleDateString()
      }, {
        header: 'Records',
        accessor: 'totalRecords'
      }, {
        header: 'Amount (PKR)',
        accessor: item => item.totalAmount.toLocaleString()
      }, {
        header: 'Status',
        accessor: item => <StatusBadge status={item.status} size="sm" data-id="element-265" />
      }]} data={mockBatches} data-id="element-264" />
      </Card>

      {/* Branch Activity Summary */}
      <Card title="Branch Activity Log" data-id="element-266">
        <div className="space-y-4" data-id="element-267">
          <div className="flex items-start space-x-3 pb-4 border-b border-gray-100" data-id="element-268">
            <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center text-green-600 font-bold text-xs" data-id="element-269">
              BA
            </div>
            <div data-id="element-270">
              <p className="text-sm font-medium text-gray-900" data-id="element-271">
                Bilal Ahmed uploaded a new batch
              </p>
              <p className="text-xs text-gray-500" data-id="element-272">
                Today at 10:30 AM • Batch #004
              </p>
            </div>
          </div>
          <div className="flex items-start space-x-3 pb-4 border-b border-gray-100" data-id="element-273">
            <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-xs" data-id="element-274">
              ZB
            </div>
            <div data-id="element-275">
              <p className="text-sm font-medium text-gray-900" data-id="element-276">
                Zainab Bibi approved Batch #003
              </p>
              <p className="text-xs text-gray-500" data-id="element-277">Yesterday at 4:15 PM</p>
            </div>
          </div>
        </div>
      </Card>
    </div>;
}